import React from 'react';
import { createTheme, FormControl, FormControlLabel, MuiThemeProvider, Switch as MuiSwitch } from '@material-ui/core';

const theme = createTheme({
  palette: {
    primary: {
      main: '#6200EE',
    },
    secondary: {
      main: '#6200EE',
    },
  },
});

export default function Switch(props) {
  const { name, label, value, onChange } = props;

  const convertToDefEventPara = (name, value) => ({
    target: {
      name,
      value,
    },
  });

  return (
    <MuiThemeProvider theme={theme}>
      <FormControl>
        <FormControlLabel
          control={
            <MuiSwitch name={name} color="primary" checked={value} onChange={(e) => onChange(convertToDefEventPara(name, e.target.checked))} />
          }
          label={label}
        />
      </FormControl>
    </MuiThemeProvider>
  );
}
